<template>
  <div class="contact-manage">
    <ba-header activeModule="Enrolled Users"></ba-header>
    <div v-loading="loading" class="u-p4 main-content">
      <div v-if="userData">
        <h2 class="c-heading__page u-mt4 u-pt2">{{ userData.name }} Contact Details</h2>
        <div class="u-mt3">
          <el-button icon="el-icon-attract" @click="showMergeDialog=true">Merge User with {{ userData.name }}</el-button>
        </div>
        <el-card v-for="_ in userData.contacts_attached" :key="_.contact_id" class="u-mt4">
          <div slot="header" class="u-pb2">
            <span>{{_.email}}</span>
            <el-button @click="willRemoveContact(_.contact_id)"
                       v-if="userData.contacts_attached.length > 1"
                       class="u-float-right"
                       type="text">Remove</el-button>
          </div>
          <div class="u-p3">
            <a :href="makeContactUrl(_.contact_id)" target="_blank" title="Will open in new tab">{{_.contact_id}}</a>
            <div class="display-inline">
            <el-tooltip class="item" effect="dark" content="Copy" placement="top-start" :enterable="false">
              <el-button type="text"
                         icon="el-icon-copy-document"
                         class="copy-creds-button"
                         @click="copyToClipboard(_.contact_id)">
              </el-button>
            </el-tooltip>
          </div>
          </div>
        </el-card>
        <merge-user-dialog v-if="!loading"
              :firstUserId="userId"
              :visible="showMergeDialog"
              :companyId="companyId"
              @closeMergeDialogEvent="onCloseMergeDialogEvent"
              @reloadContactManagement="onReloadContactManagement"></merge-user-dialog>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import config from '@/config'
  import {mapActions, mapGetters} from 'vuex'
  import MergeUserDialog from './merge-user-dialog.component.vue'
  import {copyToClipboard} from '@/shared/misc.utils'

  export default {
    name: 'manage-contact',
    components: {
      MergeUserDialog
    },
    data () {
      return {
        companyId: this.$route.params.companyId,
        userId: this.$route.query.user_id,
        loading: false,
        userData: null,
        showMergeDialog: false
      }
    },
    async mounted () {
      await this.loadUserContacts()
    },
    methods: {
      ...mapActions('shared', ['deleteUserContact']),
      copyToClipboard (value) {
        copyToClipboard(value)
      },
      makeContactUrl (contactId) {
        let company = this.companyById(this.companyId)
        return company.britecore_url + '/britecore/contacts/information?id=' + contactId
      },
      onCloseMergeDialogEvent () {
        this.showMergeDialog = false
      },
      onReloadContactManagement (userIdToNavigate) {
        if (userIdToNavigate !== this.userId) {
          // this is just to update url. It won't "reload" vue page
          this.$router.replace({name: 'manage-contact', query: {user_id: userIdToNavigate}})
        }
        this.userId = userIdToNavigate
        this.loadUserContacts()
      },
      async loadUserContacts () {
        this.loading = true
        let resp = await axios.get(`${config.url}/carrier-portal/enrolled-user/${this.userId}`)
        this.userData = resp.data
        this.loading = false
      },
      async willRemoveContact (contactId) {
        try {
          await this.$confirm(
            `This will remove the contact from BriteApps. Continue?`,
            'Multicontact edit', {
              confirmButtonText: 'Remove',
              cancelButtonText: 'Cancel',
              type: 'info'
            }
          )
        } catch (e) {
          // cancel pressed
          return
        }
        this.loading = true

        try {
          await this.deleteUserContact({userId: this.userId, contactId: contactId})
        } catch (e) {
          this.$message({
            type: 'error',
            message: `Failed to remove contact. ${e.response.message}`
          })
          return
        } finally {
          this.loading = false
        }
        await this.loadUserContacts()
      },
    },
    computed: {
      ...mapGetters('shared', ['companyById']),
    }
  }
</script>
